import { FunctionComponent } from 'react'
import { defaults } from 'react-chartjs-2'
import PieChart from '../../molecules/PieChart/PieChart'

type OwnProps = {
  pieChartData: any
}

type Props = OwnProps

export const PieChartRow: FunctionComponent<Props> = ({ pieChartData }) => {
  defaults.font.family = 'Inter'
  const pieData = pieChartData.map(data => data.percentage)

  const eggPercentageData = {
    labels: ['Extra stora', 'Stora', 'Mellan', 'Små', 'Frånsorterat'],
    datasets: [
      {
        label: 'Fördelning av ägg',
        data: pieData.slice(1, 6),
        backgroundColor: [
          'rgb(25, 205, 86)',
          'rgb(54, 162, 235)',
          'rgb(255, 205, 86)',
          'rgb(255, 99, 132)',
          'rgb(55, 25, 86)',
        ],
        hoverOffset: 10,
        radius: '65%',
      },
    ],
  }

  const discardedEggPercentageData = {
    labels: ['% Sekunda', '% Smuts', '% Knäck + Särpack', '% Odugliga'],
    datasets: [
      {
        label: 'Fördelning av frånsortering i %',
        data: pieData.slice(6, 10),
        backgroundColor: [
          'rgb(25, 205, 86)',
          'rgb(54, 162, 235)',
          'rgb(255, 165, 0)',
          'rgb(255, 99, 132)',
        ],
        hoverOffset: 10,
        radius: '65%',
      },
    ],
  }

  return (
    <>
      <PieChart data={eggPercentageData} />

      {/* <PieChart data={discardedEggPercentageData} /> */}
    </>
  )
}

export default PieChartRow
